import { useEffect, useState } from "react";
import Modal from "../../componentLibrary/Modal";
import Button from "../../componentLibrary/Button";
import { ComponentI } from "../../types";
import { renderPageComponents } from "../CreateLessonPage/utils/renderComponent";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type responseType = Record<string, any>;

interface EditChoicesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (tempResponse: responseType) => void;
  frozenComponents: ComponentI[];
  frozenAnswers: responseType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderOptions: any;
}

export default function EditChoicesModal({
  isOpen,
  onClose,
  onSave,
  frozenComponents,
  frozenAnswers,
  renderOptions,
}: EditChoicesModalProps) {
  const [tempActivityResponse, setTempActivityResponse] =
    useState<responseType>(frozenAnswers);

  useEffect(() => {
    setTempActivityResponse({ ...frozenAnswers });
  }, [frozenAnswers]);

  const handleLocalChange = (
    variable: string,
    label: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    displayAs?: string,
  ) => {
    setTempActivityResponse((prev) => {
      const newState = { ...prev };
      if (value === undefined) {
        delete newState[variable];
      } else {
        newState[variable] = {
          label,
          value,
          displayAs,
        };
      }
      return newState;
    });
  };

  const handleSaveClick = () => {
    onSave(tempActivityResponse);
  };

  return (
    <Modal
      title="Edit My Choices"
      size="xl"
      height="90vh"
      isOpen={isOpen}
      isCloseButtonVisible={false}
      onCloseModal={onClose}
    >
      <div className="flex flex-col h-full relative">
        <div className="flex-1 overflow-y-auto p-0 md:p-10 lg:p-12 pb-20 mt-6 mb-8 space-y-6 flex-grow">
          {renderPageComponents(
            frozenComponents,
            0,
            tempActivityResponse,
            tempActivityResponse,
            handleLocalChange,
            renderOptions,
            "textarea",
          )}
        </div>

        <div className="absolute bottom-0 w-full bg-white border-t border-gray-200 p-4">
          <div className="flex flex-row gap-2 justify-center">
            <Button className="px-6 py-2" onClick={handleSaveClick}>
              Save Changes
            </Button>
            <Button className="px-6 py-2" variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
